export default __webpack_public_path__ + "static/media/metropolis.59e498af.png";